// @flow
import * as React from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import _ from 'lodash';
import { memo } from 'react';
import { CallSentiment } from '../call-sentiment';
import { Portal } from '../../../../shared';
import moment from 'moment';
import { CallHistoryOutput } from '@coverright/data-access/types/enrollment';

export const LastCallSummary = memo(({calls = []}: {calls?: CallHistoryOutput[]}) => {
  const lastCall = _.orderBy(calls.filter(c => c.callHistoryAnalysis?.summary), 'createdAt')[0];

  if (!lastCall) {
    return null;
  }

  return (
    <Stack gap={1} flex={1}>
      <Portal gap={1} p={'12px 0'}>
        <Stack direction={'row'} px={1.5} alignItems={'center'} justifyContent={'space-between'}>
          {lastCall && <Typography color={'textSecondary'} variant={'body2'}>
            {moment(lastCall.createdAt).format('L LT')}
          </Typography>}
          <CallSentiment sentiment={lastCall?.callHistoryAnalysis?.sentiment} size={'small'} />
        </Stack>
        <Divider />
        <Stack gap={.5} px={1.5}>
          <Typography fontWeight={500}>Key topics</Typography>
          <Typography color={'text.secondary'} variant={'body2'}>
            {lastCall?.callHistoryAnalysis?.topics?.map(_.upperFirst).join(', ')}
          </Typography>
        </Stack>
        <Divider />
        <Stack gap={.5} px={1.5}>
          <Typography fontWeight={500}>Summary</Typography>
          <Typography sx={{whiteSpace: 'pre-line'}} color={'text.secondary'} variant={'body2'}>
            {lastCall?.callHistoryAnalysis?.summary}
          </Typography>
        </Stack>

      </Portal>
    </Stack>
  );
});
